// Banner Carousels
const bannerSliders = document.querySelectorAll('.js-slider--banner'),
    bannerSliderNav = document.querySelectorAll('.js-slider-nav--banner'),
    bannerSliderNavNext = document.querySelectorAll('.js-next-slide--banner'),
    bannerSliderNavPrev = document.querySelectorAll('.js-prev-slide--banner'),
    bannerSliderPagination = document.querySelectorAll('.js-pagination--banner');

bannerSliders.forEach((el, i) => {
    const slider = new Swiper(el, {
        containerModifierClass: 'slider',
        wrapperClass: 'slider__wrapper',
        slideClass: 'slide',
        slideActiveClass: 'slide--active',
        slidesPerView: 'auto',
        loop: false,
        loopedSlides: 2,
        speed: 500,
        spaceBetween: 0,
        centeredSlides: true,
        watchSlidesVisibility: true,
        uniqueNavElements: true,
        initialSlide: 0,
        navigation: {
            nextEl: bannerSliderNavNext[i],
            prevEl: bannerSliderNavPrev[i],
            disabledClass: 'slider__button--disabled'
        },
        pagination: {
            el: bannerSliderPagination[i],
            type: 'bullets',
            clickable: true
        },
        keyboard: {
            enabled: true,
            onlyInViewport: true
        }
    });
});


// Card Sliders
const entryListSliders = document.querySelectorAll('.js-slider--entry-list'),
    swiperInstances = [],
    delay = 250;

let throttled = false;
    
function handleEntryLists() {
    entryListSliders.forEach((el) => {
        // Instantiate swiper if window is < 800px
        if (window.innerWidth < 800) {
            swiperInstances.push(new Swiper(el, {
                containerModifierClass: 'slider',
                wrapperClass: 'slider__wrapper',
                slideClass: 'slide',
                slidesPerView: 'auto',
                slidesOffsetAfter: -8,
                freeMode: true,
                keyboard: {
                    enabled: true,
                    onlyInViewport: true
                }
            }));
        } else {
            // Destroy any swiper instances
            swiperInstances.forEach(swiper => {
                swiper.destroy(true, true);
            });
        }
    });
}

// window.resize event listener
window.addEventListener('resize', function() {
    // Only run if we're not throttled
    if (!throttled) {
        handleEntryLists();

        throttled = true;

        // Set a timeout to un-throttle
        setTimeout(function() {
            throttled = false;
        }, delay);
    }  
});

handleEntryLists();